import React, { useState, useEffect } from 'react';

const Typewriter = ({ text, speed = 50 }) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    if (!text) {
      setDisplayedText('');
      return;
    }

    // Reset displayed text when text prop changes
    setDisplayedText('');
    
    let i = 0;
    const intervalId = setInterval(() => {
      if (i < text.length) {
        setDisplayedText(text.substring(0, i + 1));
        i++;
      } else {
        clearInterval(intervalId);
      }
    }, speed);

    return () => clearInterval(intervalId);
  }, [text, speed]);

  if (!text) {
    return <p className="text-gray-500 italic">No analysis available.</p>;
  }

  return <p className="text-gray-700 whitespace-pre-wrap">{displayedText}</p>;
};

export default Typewriter;